import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from '../App';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');

  // Where the user was before the session expired (set by ProtectedRoute).
  const from = location.state?.from?.pathname
    ? location.state.from.pathname + (location.state.from.search || '')
    : '/dashboard';
  // Set by the axios 401 interceptor; read once so it doesn't stick around.
  const [sessionExpired] = useState(() => {
    const flag = sessionStorage.getItem('pf_session_expired') === '1';
    if (flag) sessionStorage.removeItem('pf_session_expired');
    return flag;
  });

  if (user) return <Navigate to={from} replace />;

  async function handleGoogleSuccess(credentialResponse) {
    setError('');
    try {
      const { data } = await axios.post('/auth/verify-google', {
        credential: credentialResponse.credential,
      });
      login(data.token, {
        email: data.email,
        name: data.name,
        picture: data.picture,
      });
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err.response?.data?.error || 'Sign-in failed. Please try again.';
      setError(msg);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ fontSize: 40, marginBottom: 16 }}>📦</div>
        <h1>Product Features</h1>
        <p className="subtitle">Track and manage product features across your team</p>

        {sessionExpired && !error && (
          <div className="error-msg">Your session expired. Please sign in again.</div>
        )}
        {error && <div className="error-msg">{error}</div>}

        <div className="google-btn-wrap">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setError('Google sign-in failed. Please try again.')}
            theme="filled_blue"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>
      </div>
    </div>
  );
}
